class AccountActions implements MerchantosAccountActions {
  /**
   * Ensures that the account close form meets the required specifications:
   * that the comment box contains at least ten characters and that the reason
   * has a value
   *
   * @param form HTML form node
   */
  validateCloseAccount: MerchantosAccountActions['validateCloseAccount'] = form => {
    const $form = $(form);
    const $reason = $form.find('select[name="reason"]');
    const $reasonError = $form.find('#reason-error');
    const $comment = $form.find('textarea[name="comment"]');
    const $commentError = $form.find('#comment-error');
    let valid = true;

    // Hide errors from earlier attempts to submit the form
    $reasonError.hide();
    $commentError.hide();

    if (!$reason.val()) {
      valid = false;
      $reasonError.show();
    }
    if (!this.validCloseComments($comment)) {
      valid = false;
      $commentError.show();
    }
    return valid;
  };

  // -------------------------PRIVATE HELPERS --------------------------//

  private validCloseComments = ($comment: JQuery<Element>) => {
    return ($comment.val() as string).trim().length > 10;
  };
}

window.merchantos.account_actions = new AccountActions();

$(() =>
  $('#section').on('submit', '#close_account_form', function submitCloseAccount(e) {
    if (!window.merchantos.account_actions.validateCloseAccount(this)) {
      e.preventDefault();
    }
  })
);
